import React from "react";
import ReactPlayer from "react-player";
import { ElementType } from "../../../shared/types";
import { ElementPlaceholder } from "../../../shared/Components/ElementPlaceholder/ElementPlaceholder";
const VideoView = ({
  element
}) => {
  const videoSettings = element?.settings;
  const VideoReactPlayer = typeof ReactPlayer === "function" ? ReactPlayer : ReactPlayer.default;
  return /*#__PURE__*/React.createElement(React.Fragment, null, videoSettings?.url ? /*#__PURE__*/React.createElement("div", {
    "data-test": "VideoView",
    style: {
      display: "inline-block",
      width: "100%",
      height: "100%",
      borderRadius: `${videoSettings?.borderRadius}px`,
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement(VideoReactPlayer, {
    key: `${videoSettings?.url}-${Date.now()}` // this is to force the video to re-render after mounting
    ,
    light: !videoSettings?.autoplay // the autoplay video doesn't work when the light prop is true that is why we used it only when the autoplay is false
    ,
    url: videoSettings?.url,
    controls: videoSettings?.controls,
    muted: videoSettings?.muted,
    loop: videoSettings?.loop,
    playing: videoSettings?.autoplay,
    width: "100%",
    height: "100%"
  })) : /*#__PURE__*/React.createElement(ElementPlaceholder, {
    elementType: ElementType.Video
  }));
};
export { VideoView };
//# sourceMappingURL=VideoView.js.map